module.exports = __webpack_public_path__ + "static/media/image_terapia_t_3.9f220dbf.png";